
import {Vue, Component, Prop} from 'vue-property-decorator'
import CustomWrapper from '@/components/CustomWrapper.vue'

@Component({
  name: 'c-simple-card-summary',
  components: { CustomWrapper }
})
export default class CSimpleCardSummary extends Vue {
  @Prop({ type: String, default: 'p' }) tag!: string

}
